import * as React from "react";
import Image from "antd/es/image";
import Button from "antd/es/button";
import { getWallets } from "@talismn/connect-wallets";
import { WalletSelect } from '@talismn/connect-components';

import { ConnectButtonProps } from "./types";

const wallets = getWallets().filter(wallet => wallet.installed);

export const LiberlandConnect: React.FunctionComponent<ConnectButtonProps> = (props) => {
    const [isOpen, setIsOpen] = React.useState(false);

    if (!wallets.length) {
        return null;
    }

    return (
        <WalletSelect
            dappName="LiberStake"
            open={isOpen}
            triggerComponent={(
                <Button
                    size="large"
                    className="LiberlandButton"
                    icon={<Image src={require("../logo-small.png")} width="22px" height="22px" preview={false} />}
                >
                    Select
                </Button>
            )}
            showAccountsList
            onWalletConnectClose={() => setIsOpen(false)}
            onAccountSelected={(account) => props.selectWallet(account.address)}
        />
    );
};